<template>
	<div>
		<v-tabs v-model="activeTab" background-color="whitesmoke" centered color="secondary" slider-color="secondary">
			<v-tab :key="0">اطلاعات نماینده</v-tab>
			<v-tab :key="1">تنظیمات وام های نماینده</v-tab>

			<v-tabs-items v-model="activeTab" touchless class="mt-3">
				<v-tab-item :key="0">
					<v-form ref="form" class="mx-2" lazy-validation @submit.prevent="submit">
						<v-row>
							<v-col cols="12" md="6">
								<v-text-field ref="username" class="left-input" v-model="localData.userName" label="نام کاربری" hint="نام کاربری به صورت خودکار پر می شود" persistent-hint disabled />
							</v-col>
							<v-col cols="12" md="6">
								<v-checkbox color="secondary" v-model="localData.isActive" :label="'اکانت فعال'" />
							</v-col>
						</v-row>
						<v-row>
							<v-col cols="12" md="6" class="py-0">
								<v-text-field ref="firstName" v-model="localData.firstName" label="نام نماینده*" :error-messages="errorMessages" :rules="[() => !!localData.firstName || 'نام نماینده را وارد کنید']" required />
							</v-col>
							<v-col cols="12" md="6" class="py-0">
								<v-text-field ref="businessName" v-model="localData.businessName" label="نام تجاری*" :error-messages="errorMessages" :rules="[() => !!localData.businessName || 'نام تجاری را وارد کنید']" required />
							</v-col>
							<v-col cols="12" md="6" class="py-0">
								<v-text-field ref="nationalCode" maxlength="10" v-model="localData.nationalCode" label="کد ملی*" :error-messages="errorMessages" :rules="[(val) => !!val || 'کد ملی را وارد کنید']" required />
							</v-col>
							<v-col cols="12" md="6" class="py-0">
								<v-text-field ref="shenasname" v-model="localData.shenasname" label="شماره شناسنامه*" :error-messages="errorMessages" :rules="[(val) => !!val || 'شماره شناسنامه را وارد کنید']" required />
							</v-col>
							<v-col cols="12" md="6" class="py-0">
								<v-text-field ref="fatherName" v-model="localData.fatherName" label="نام پدر" />
							</v-col>
							<v-col cols="12" md="6" class="py-0">
								<v-text-field ref="mobile" v-model="localData.mobile" maxlength="11" label="موبایل*" :error-messages="errorMessages" :rules="[(val) => !!val || 'موبایل را وارد کنید']" required />
							</v-col>
							<v-col cols="12" md="6" class="py-0">
								<v-text-field ref="phone" v-model="localData.phone" maxlength="20" label="تلفن ثابت" />
							</v-col>
						</v-row>
						<v-row>
							<v-col cols="12" md="6">
								<v-text-field class="left-input" v-model="localData.password" persistent-hint :hint="localData.id !== 0 ? 'در صورت خالی بودن پسورد تغییر نخواهد کرد' : 'حداقل 8 کاراکتر'" :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'" :rules="[(val) => !!val || (localData.id != 0 && !val) || 'کلمه عبور را وارد کنید']" :error-messages="errorMessages" :type="show1 ? 'text' : 'password'" name="password" label="کلمه عبور*" @click:append="show1 = !show1" />
							</v-col>
							<v-col cols="12" md="6">
								<v-text-field class="left-input" v-model="localData.confirmPassword" :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'" :rules="[() => localData.confirmPassword === localData.password || 'تکرار کلمه عبور با کلمه عبور مطابقت ندارد']" :error-messages="errorMessages" :type="show2 ? 'text' : 'password'" name="confirmPassword" label="تکرار کلمه عبور*" @click:append="show2 = !show2" />
							</v-col>
							<v-col cols="12" md="3" class="py-0">
								<v-text-field ref="city" v-model="localData.city" label="شهر*" :rules="[() => !!localData.city || 'شهر را وارد کنید']" />
							</v-col>
							<v-col cols="12" md="6" class="py-0">
								<v-text-field ref="address" v-model="localData.address" label="آدرس*" :rules="[() => !!localData.address || 'آدرس را وارد کنید']" />
							</v-col>
							<v-col cols="12" md="3" class="py-0">
								<v-text-field ref="postalCode" v-model="localData.postalCode" label="کد پستی*" maxlength="10" :rules="[(val) => !!val || 'کد پستی را وارد کنید']" required />
							</v-col>
							<v-col cols="12" md="12" class="">
								<div style="border-radius: 5px;background:#eee;padding: 10px;">
									<div class="text-center secondary--text mb-2">شماره حساب ها</div>
									<v-card v-for="(item, index) in bankAccounts" :key="index" class="mb-3 pa-3" elevation="0" style="border: 1px solid #dca6e5">
										<v-row>
											<v-col cols="12" md="5" class="py-0 my-0">
												<v-text-field v-model="item.accountNumber" label="شماره حساب/شبا*" :error-messages="errorMessages" :rules="[(val) => !!val || 'شماره حساب را وارد کنید']" required />
											</v-col>
											<v-col cols="12" md="3" class="py-0 my-0">
												<v-text-field v-model="item.bank" label="بانک*" :error-messages="errorMessages" :rules="[(val) => !!val || 'نام بانک را وارد کنید']" required />
											</v-col>
											<v-col cols="12" md="3" class="py-0 my-0">
												<v-text-field v-model="item.branch" label="شعبه*" :error-messages="errorMessages" :rules="[(val) => !!val || 'شعبه را وارد کنید']" required />
											</v-col>
											<v-col cols="1" md="1" class="my-0 py-0 d-flex flex-column justify-center">
												<v-btn @click="removeBankAccount(item, index)" class="" x-small icon dark color="pink" title="حذف">
													<v-icon dark>
														mdi-trash-can-outline
													</v-icon>
												</v-btn>
											</v-col>
										</v-row>
									</v-card>
									<div class="text-center mt-5">
										<v-btn class="mx-auto" color="secondary" dark @click="addBankAccount" small>
											<v-icon dark>
												mdi-plus-circle-outline
											</v-icon>
											شماره حساب جدید
										</v-btn>
									</div>
								</div>
							</v-col>
						</v-row>
						<v-row>
							<v-col cols="12" md="12">
								<v-checkbox color="secondary" v-model="localData.smsActiveForMembers" :label="'پیامک های یادآوری به مشتریان فعال باشد؟'" />
							</v-col>
						</v-row>
						<div class="mt-3">
							<small>*فیلدهای ستاره دار ضروری هستند.</small>
						</div>
					</v-form>
				</v-tab-item>
				<v-tab-item :key="1">
					<div class="mb-2 text-center">وام های قابل درخواست توسط نماینده را اضافه کنید:</div>
					<v-card v-for="(item, index) in localData.agentLoans" :key="index" class="mb-3 pa-3" elevation="2" style="border: 1px solid #dca6e5">
						<v-row>
							<v-col cols="11" class="py-0 my-0">
								<v-row class="my-0">
									<v-col cols="12" md="12" class="py-0 my-0">
										<v-select v-model="item.loan" clearable required single-line return-object :items="loans" label="نوع وام" item-text="title" item-value="id" />
									</v-col>
								</v-row>
								<v-row>
									<v-col cols="12">
										<v-card color="#eee">
											<v-card-title class="justify-space-between grey lighten-2 black--text pa-1 px-3">
												<div class="text-h4">
													پول نقد
												</div>
												<div>
													<div>
														<small class="">درصد قابل واریز به شما: </small>
														<span class="red--text">{{ (currentAgent && currentAgent.agentLoans && item.loan ? currentAgent.agentLoans.find(x =>
															x.loanId === item.loan.id).percent : 0) }} %</span>
													</div>
													<div>
														<small class="">تعداد روز پیش فرض تسویه با شما: </small>
														<span class="red--text">{{ (currentAgent && currentAgent.agentLoans && item.loan ? currentAgent.agentLoans.find(x =>
															x.loanId === item.loan.id).defaultCheckoutDays : '') }}</span>
													</div>
												</div>
											</v-card-title>
											<v-card-text>
												<v-row>
													<v-col cols="12" md="6">
														<v-text-field v-model="item.percent" label="درصد نماینده از کل مبلغ وام" maxlength="6" :rules="[(val) => val >= 0 || 'درصد نماینده نمی تواند کمتر از 0 باشد', (val) => val <= 100 || 'درصد نماینده نمی تواند بیشتر از 100 باشد']" />
													</v-col>
													<v-col cols="12" md="6">
														<v-text-field type="number" v-model="item.defaultCheckoutDays" label="تعداد روز پیش فرض تسویه" />
													</v-col>
												</v-row>
											</v-card-text>
										</v-card>
									</v-col>
								</v-row>
								<v-row>
									<v-col cols="12">
										<v-card color="#eee">
											<v-card-title class="justify-space-between grey lighten-2 black--text pa-1 px-3">
												<div class="text-h4">
													کالا
												</div>
												<div>
													<div>
														<small class="">درصد قابل واریز به شما: </small>
														<span class="red--text">{{ (currentAgent && currentAgent.agentLoans && item.loan ? currentAgent.agentLoans.find(x =>
															x.loanId === item.loan.id).productPercent : 0) }} %</span>
													</div>
													<div>
														<small class="">تعداد روز پیش فرض تسویه با شما: </small>
														<span class="red--text">{{ (currentAgent && currentAgent.agentLoans && item.loan ? currentAgent.agentLoans.find(x =>
															x.loanId === item.loan.id).productCheckoutDays : '') }}</span>
													</div>
												</div>
											</v-card-title>
											<v-card-text>
												<v-row>
													<v-col cols="12" md="6">
														<v-text-field v-model="item.productPercent" label="درصد نماینده از کل مبلغ وام" maxlength="6" :rules="[(val) => val >= 0 || 'درصد نماینده نمی تواند کمتر از 0 باشد', (val) => val <= 100 || 'درصد نماینده نمی تواند بیشتر از 100 باشد']" />
													</v-col>
													<v-col cols="12" md="6">
														<v-text-field type="number" v-model="item.productCheckoutDays" label="تعداد روز پیش فرض تسویه" />
													</v-col>
												</v-row>
											</v-card-text>
										</v-card>
									</v-col>
								</v-row>
							</v-col>
							<v-col cols="1" class="my-0 py-0 d-flex align-center">
								<v-btn @click="remove(item, index)" class="" x-small color="pink" icon dark title="حذف">
									<v-icon>
										mdi-trash-can-outline
									</v-icon>
								</v-btn>
							</v-col>
						</v-row>
					</v-card>
					<div class="text-center mt-5">
						<v-btn class="mx-auto" color="secondary" dark @click="add">
							<v-icon dark>
								mdi-plus-circle-outline
							</v-icon>
							افزودن وام
						</v-btn>
					</div>
				</v-tab-item>
			</v-tabs-items>
		</v-tabs>
		<v-card-actions>
			<v-spacer />
			<v-btn @click="$emit('callbck', false)">
				بستن
			</v-btn>
			<v-btn color="blue" dark @click="submit" :loading="loading">
				ذخیره
			</v-btn>
		</v-card-actions>

	</div>
</template>

<script>
	import api from '@/util/app-api'
	import toast from '@/util/toast'
	import { call, get } from 'vuex-pathify'
	import { emptyId } from '@/util/emptyId'
	import VuePersianDatetimePicker from 'vue-persian-datetime-picker'

	export default {
		name: 'ModifyAgent',
		components: {
			OffDates: () => import('@/components/forms/OffDates'),
			'date-picker': VuePersianDatetimePicker,
		},
		props: {
			data: { type: Object },
		},
		data() {
			return {
				errorMessages: '',
				localData: {},
				datePickerValidatioin: '',
				show1: false,
				show2: false,
				loading: false,
				activeTab: 0,
				loans: [],
				bankAccounts: [],
				currentAgent: null
			}
		},
		mounted() {
			this.loadCurrentAgent()
			this.loadLoans().then(res => {
				this.prepareData()
			})
		},
		computed: {
			isSuperAdmin: get('auth/isSuperAdmin')
		},
		methods: {
			loadLoans() {
				return api.get('agent/userLoanRequest/loanslist', null)
					.then(
						response => {
							this.loans = response
						})
					.catch(err => {
						toast.error(err.message)
					})
			},
			add() {
				if (!this.localData.agentLoans)
					this.localData.agentLoans = []
				this.localData.agentLoans.push({
					id: emptyId,
					loanId: '',
					loan: null,
					agentId: this.localData.id,
					percent: 0
				})
			},
			remove(item, index) {
				this.localData.agentLoans.splice(index, 1)
			},
			submit() {
				if (!this.$refs.form.validate()) { return }
				if (!this.bankAccounts.length) {
					toast.error('ثبت حداقل یک شماره حساب الزامی است')
					return
				}
				if (this.localData.agentLoans?.length) {
					if (this.localData.agentLoans.some(x => !x.loan)) {
						toast.error('نوع وام باید برای تمام وام های نماینده، انتخاب شده باشد.')
						return
					}
					let validation = true
					this.localData.agentLoans.forEach(x => {
						x.loanId = x.loan?.id
						let currentAgentLoan = this.currentAgent.agentLoans.find(ag => ag.loanId === x.loan.id)
						if (currentAgentLoan && currentAgentLoan.percent < x.percent) {
							toast.error(`در ردیف وام ${x.loan.title}، درصد نماینده از درصد شما بیشتر شده است.`)
							validation = false
						}
						if (currentAgentLoan && currentAgentLoan.defaultCheckoutDays > x.defaultCheckoutDays && x.defaultCheckoutDays > 0) {
							toast.error(`در ردیف وام ${x.loan.title}، تعداد روز تسویه نماینده از تعداد روز تسویه شما کمتر شده است.`)
							validation = false
						}
						if (currentAgentLoan && currentAgentLoan.productPercent < x.productPercent) {
							toast.error(`در ردیف وام ${x.loan.title}، درصد نماینده از درصد شما بیشتر شده است.`)
							validation = false
						}
						if (currentAgentLoan && currentAgentLoan.productCheckoutDays > x.productCheckoutDays && x.productCheckoutDays > 0) {
							toast.error(`در ردیف وام ${x.loan.title}، تعداد روز تسویه نماینده از تعداد روز تسویه شما کمتر شده است.`)
							validation = false
						}
					})
					if (!validation)
						return
				}
				this.loading = true
				let data = {}
				data = Object.assign(data, this.localData)
				data.bankAccountsJson = JSON.stringify(this.bankAccounts)
				api.post('agent/agent/' + (this.localData.id === 0 ? 'create' : 'edit'), data)
					.then(response => {
						toast.success('اطلاعات با موفقیت ذخیره شد.')
						this.$emit('callbck', true)
					})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(() => {
						this.loading = false
					})
			},
			loadCurrentAgent() {
				api.get('agent/agent/get', null)
					.then(response => {
						this.currentAgent = response
					})
					.catch(err => {
						toast.error(err.message)
					})
			},
			prepareData() {
				if (!this.data) {
					this.data = { id: 0 }
				}
				if (!this.data.id) {
					this.data.id = 0
				}
				api.get('agent/agent/get/' + this.data.id, null)
					.then(response => {
						this.localData = response
						if (this.data.id === 0) Object.assign(this.localData, this.data)
						let temp = []
						response.agentLoans?.forEach(x => {
							temp.push({
								id: x.id,
								loanId: x.loanId,
								loan: this.loans.find(l => l.id === x.loanId),
								agentId: x.agentId,
								percent: x.percent,
								defaultCheckoutDays: x.defaultCheckoutDays,
								productPercent: x.productPercent,
								productCheckoutDays: x.productCheckoutDays,
							})
						})
						this.localData.agentLoans = [...temp]
						this.bankAccounts = this.localData.bankAccountsJson ? JSON.parse(this.localData.bankAccountsJson) : []
					})
					.catch(err => {
						toast.error(err.message)
					})
			},
			removeBankAccount(item, index) {
				this.bankAccounts.splice(index, 1)
			},
			addBankAccount() {
				let newItem = {
					accountNumber: '',
					bank: '',
					branch: '',
				}
				this.bankAccounts.push(newItem)
			}
		}
	}
</script>
<style></style>
